import { render } from "./CustomerDueReceive.vue?vue&type=template&id=ff72de0c&scoped=true"
import script from "./CustomerDueReceive.vue?vue&type=script&lang=js"
export * from "./CustomerDueReceive.vue?vue&type=script&lang=js"

import "./CustomerDueReceive.vue?vue&type=style&index=0&id=ff72de0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff72de0c"]])

export default __exports__